var _linearGradient, _circle, _g, _linearGradient2, _circle2, _g2, _linearGradient3, _circle3, _radialGradient, _circle4, _linearGradient4, _circle5, _linearGradient5, _path, _linearGradient6, _circle6, _radialGradient2, _circle7, _linearGradient7, _use, _linearGradient8, _use2, _linearGradient9, _use3, _linearGradient0, _use4, _linearGradient1, _use5, _linearGradient10, _use6, _path2, _use7, _use8, _path3, _use9, _use0, _path4, _use1, _use10, _path5, _linearGradient11, _use11, _linearGradient12, _use12, _path6, _linearGradient13, _path7, _linearGradient14, _path8, _path9, _linearGradient15, _use13, _linearGradient16, _use14, _path0, _use15, _path1, _use16, _path10, _use17, _path11, _linearGradient17, _path12, _linearGradient18, _path13, _linearGradient19, _use18, _linearGradient20, _path14, _linearGradient21, _use19, _linearGradient22, _path15, _linearGradient23, _use20, _linearGradient24, _path16, _linearGradient25, _path17, _linearGradient26, _path18, _g3, _g4, _path19, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVipIconEn = function SvgVipIconEn(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 558.8 579.6",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    gradientUnits: "userSpaceOnUse",
    x1: 279.402,
    y1: 579.576,
    x2: 279.402,
    y2: 20.773
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 279.4,
    cy: 300.2,
    r: 279.4,
    fill: "url(#A)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    gradientUnits: "userSpaceOnUse",
    x1: 279.402,
    y1: 20.773,
    x2: 279.402,
    y2: 579.576
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279.4 21.8c37.6 0 74 7.4 108.4 21.9 33.2 14 62.9 34.1 88.5 59.7s45.6 55.3 59.7 88.5c14.5 34.3 21.9 70.8 21.9 108.4s-7.4 74-21.9 108.4c-14 33.2-34.1 62.9-59.7 88.5s-55.3 45.6-88.5 59.7c-34.3 14.5-70.8 21.9-108.4 21.9s-74-7.4-108.4-21.9c-33.2-14-62.9-34.1-88.5-59.7s-45.6-55.3-59.7-88.5C8.4 374.2 1 337.8 1 300.2s7.4-74 21.9-108.4c14-33.2 34.1-62.9 59.7-88.5s55.3-45.6 88.5-59.7c34.3-14.5 70.7-21.8 108.3-21.8m0-1C125.1 20.8 0 145.9 0 300.2s125.1 279.4 279.4 279.4 279.4-125.1 279.4-279.4S433.7 20.8 279.4 20.8z",
    fill: "url(#B)"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    gradientUnits: "userSpaceOnUse",
    x1: 279.402,
    y1: 558.803,
    x2: 279.402,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.4,
    cy: 279.4,
    r: 279.4,
    fill: "url(#C)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    gradientUnits: "userSpaceOnUse",
    x1: 279.402,
    y1: 0,
    x2: 279.402,
    y2: 558.803
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fce2ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc9a11"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279.4 3c37.3 0 73.5 7.3 107.6 21.7 32.9 13.9 62.5 33.9 87.9 59.2 25.4 25.4 45.3 54.9 59.2 87.9 14.4 34.1 21.7 70.3 21.7 107.6s-7.3 73.5-21.7 107.6c-13.9 32.9-33.9 62.5-59.2 87.9-25.4 25.4-54.9 45.3-87.9 59.2-34.1 14.4-70.3 21.7-107.6 21.7s-73.5-7.3-107.6-21.7c-32.9-13.9-62.5-33.9-87.9-59.2C58.5 449.5 38.6 420 24.7 387 10.3 352.9 3 316.7 3 279.4s7.3-73.5 21.7-107.6C38.6 138.9 58.6 109.3 84 84c25.4-25.4 54.9-45.3 87.9-59.2C205.9 10.3 242.1 3 279.4 3m0-3C125.1 0 0 125.1 0 279.4s125.1 279.4 279.4 279.4 279.4-125.1 279.4-279.4S433.7 0 279.4 0z",
    fill: "url(#D)"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    gradientUnits: "userSpaceOnUse",
    x1: 279.402,
    y1: 552.571,
    x2: 279.402,
    y2: 6.232
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e9e9e"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.4,
    cy: 279.4,
    r: 273.2,
    fill: "url(#E)"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "F",
    cx: 279.402,
    cy: 279.402,
    r: 273.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopOpacity: 0.515
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.4,
    cy: 279.4,
    r: 273.2,
    fill: "url(#F)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    gradientUnits: "userSpaceOnUse",
    x1: 279.402,
    y1: 526.604,
    x2: 279.402,
    y2: 32.199
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.4,
    cy: 279.4,
    r: 247.2,
    fill: "url(#G)"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    gradientUnits: "userSpaceOnUse",
    x1: 279.402,
    y1: 32.199,
    x2: 279.402,
    y2: 526.604
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7b53c"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M279.4 33.7c33.2 0 65.3 6.5 95.6 19.3 29.3 12.4 55.5 30.1 78.1 52.7s40.3 48.8 52.7 78.1c12.8 30.3 19.3 62.5 19.3 95.6s-6.5 65.3-19.3 95.6c-12.4 29.3-30.1 55.5-52.7 78.1s-48.8 40.3-78.1 52.7c-30.3 12.8-62.5 19.3-95.6 19.3s-65.3-6.5-95.6-19.3c-29.3-12.4-55.5-30.1-78.1-52.7S65.4 404.3 53 375c-12.8-30.3-19.3-62.5-19.3-95.6s6.5-65.3 19.3-95.6c12.4-29.3 30.1-55.5 52.7-78.1s48.8-40.3 78.1-52.7c30.3-12.8 62.4-19.3 95.6-19.3m0-1.5c-136.5 0-247.2 110.7-247.2 247.2s110.7 247.2 247.2 247.2 247.2-110.7 247.2-247.2S415.9 32.2 279.4 32.2z",
    fill: "url(#H)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    gradientUnits: "userSpaceOnUse",
    x1: 279.402,
    y1: 505.831,
    x2: 279.402,
    y2: 52.972
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928,
    stopColor: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c7c7c"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.4,
    cy: 279.4,
    r: 226.4,
    fill: "url(#I)"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "J",
    cx: 279.402,
    cy: 279.402,
    r: 226.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopOpacity: 0.515
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.4,
    cy: 279.4,
    r: 226.4,
    fill: "url(#J)"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    gradientUnits: "userSpaceOnUse",
    x1: 225.391,
    y1: 128.299,
    x2: 225.391,
    y2: 84.673
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r",
    fill: "url(#K)"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    gradientUnits: "userSpaceOnUse",
    x1: 225.391,
    y1: 128.294,
    x2: 225.391,
    y2: 84.67
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    fill: "url(#L)"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    gradientUnits: "userSpaceOnUse",
    x1: 225.388,
    y1: 128.299,
    x2: 225.388,
    y2: 84.673
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r",
    x: 64.4,
    fill: "url(#M)"
  })), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    gradientUnits: "userSpaceOnUse",
    x1: 289.788,
    y1: 128.294,
    x2: 289.788,
    y2: 84.67
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    fill: "url(#N)"
  })), _linearGradient1 || (_linearGradient1 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    gradientUnits: "userSpaceOnUse",
    x1: 352.108,
    y1: 128.299,
    x2: 352.108,
    y2: 84.673
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    fill: "url(#O)"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse",
    x1: 352.108,
    y1: 128.294,
    x2: 352.108,
    y2: 84.67
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v",
    fill: "url(#P)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M225.1 88.8l5.5 17.1h16.6l-12.5 10.4 3.9 16.1-13.5-7.4-13.5 7.4 4.4-16.1-12.4-10.4h16.6z",
    opacity: 0.5
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r",
    fill: "url(#K)"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    fill: "url(#L)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M289.5 88.8l5.5 17.1h16.6l-12.5 10.4 3.9 16.1-13.5-7.4-13.5 7.4 4.4-16.1-12.4-10.4h16.6z",
    opacity: 0.5
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r",
    x: 64.4,
    fill: "url(#M)"
  })), _use0 || (_use0 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    fill: "url(#N)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M351.8 88.8l5.5 17.1h16.6l-12.4 10.4 3.8 16.1-13.5-7.4-13.4 7.4 4.4-16.1-12.5-10.4h16.6z",
    opacity: 0.5
  })), _use1 || (_use1 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    fill: "url(#O)"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v",
    fill: "url(#P)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M225.1 429.5l5.5 17.1h16.6L234.7 457l3.9 16.1-13.5-7.4-13.5 7.4L216 457l-12.4-10.4h16.6z",
    opacity: 0.5
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    gradientUnits: "userSpaceOnUse",
    x1: 225.391,
    y1: 128.294,
    x2: 225.391,
    y2: 84.668
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r",
    y: 340.7,
    fill: "url(#Q)"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    gradientUnits: "userSpaceOnUse",
    x1: 225.391,
    y1: 128.276,
    x2: 225.391,
    y2: 84.652
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    y: 340.7,
    fill: "url(#R)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M289.5 429.5l5.5 17.1h16.6L299.1 457l3.9 16.1-13.5-7.4-13.5 7.4 4.4-16.1-12.4-10.4h16.6z",
    opacity: 0.5
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    gradientUnits: "userSpaceOnUse",
    x1: 289.788,
    y1: 468.994,
    x2: 289.788,
    y2: 425.368
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M289.5 425.4l5.5 17.1h16.6l-12.5 10.4L303 469l-13.5-7.5L276 469l4.4-16.1-12.4-10.4h16.6z",
    fill: "url(#S)"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    gradientUnits: "userSpaceOnUse",
    x1: 289.788,
    y1: 468.976,
    x2: 289.788,
    y2: 425.352
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M289.5 426.4l5.2 16.2.1.2h16l-11.8 9.9-.1.1v.2l3.7 15.5-12.9-7.1-.1-.1-.1.1-12.9 7.1 4.2-15.4.1-.2-.1-.1-11.8-9.9h16l.1-.2 4.4-16.3m0-1l-4.9 17.1H268l12.5 10.4L276 469l13.5-7.5L303 469l-3.9-16.1 12.5-10.4H295l-5.5-17.1z",
    fill: "url(#T)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M351.8 429.5l5.5 17.1h16.6L361.5 457l3.8 16.1-13.5-7.4-13.4 7.4 4.4-16.1-12.5-10.4h16.6z",
    opacity: 0.5
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    gradientUnits: "userSpaceOnUse",
    x1: 352.108,
    y1: 128.294,
    x2: 352.108,
    y2: 84.668
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    y: 340.7,
    fill: "url(#U)"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    gradientUnits: "userSpaceOnUse",
    x1: 352.108,
    y1: 128.276,
    x2: 352.108,
    y2: 84.652
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v",
    y: 340.7,
    fill: "url(#V)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M111.6 157.1c3.3-.7 9.1-1.2 14.8-1.2 7.1 0 12.1.9 16.1 3.7 3.5 2.4 5.7 6.2 5.7 11 0 5.3-3.1 10.2-9.3 12.6v.3c6.5 1.7 11.4 6.8 11.4 14.3 0 4.5-1.9 8.9-5.3 12-3.9 3.6-10.5 5.5-20.9 5.5-5.5 0-9.7-.4-12.4-.8v-57.4zm11.2 23h4.1c6.4 0 10.2-3.4 10.2-8.2 0-5.8-4.3-7.7-9.3-7.7-2.4 0-3.9.2-4.9.4v15.5zm0 8.2v18.2c1.1.2 2.5.3 4.5.3 6.1 0 11.2-2.7 11.2-9.3 0-6.7-5.8-9.2-11.5-9.2h-4.2zm68.8 17v9.4H159v-58.3h31.4v9.4h-20.2v14.1h19v9.2h-19v16.2h21.4z"
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M291.7 184.8c0 20.3-10.3 30.7-24.8 30.7-15.4 0-24.1-12.9-24.1-29.8 0-17.4 9.6-30.3 24.9-30.3 16.1 0 24 13.8 24 29.4zm-37.1.7c0 11.4 4.5 20.9 12.7 20.9 8.3 0 12.7-9.3 12.7-21.1 0-10.7-4-20.6-12.6-20.6-8.8-.1-12.8 10.1-12.8 20.8z"
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M399.1 205.3v9.4h-32.6v-58.3h31.4v9.4h-20.2v14.1h19v9.2h-19v16.2h21.4z"
  })), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M224.6 226h38.3l-56.4 185.3h-40.7L112 226h39l21 81.9c5.5 21.9 11.1 44.1 14.9 66.5h.7c4.1-22.2 9.6-44.8 15.4-66.5l21.6-81.9zm57.3 185.3V226h35.7v185.3h-35.7zm71.8 0V228.4c11.6-2.2 27.5-3.9 48-3.9 23.4 0 41 4.6 52.8 14.7 11.1 9.4 17.8 24.3 17.8 41.4 0 50.8-42.4 62.2-70.1 62.2-5.1 0-9.4-.2-13-1v69.4h-35.5zm35.4-97.3c3.4.7 7.2 1 12.5 1 22.2 0 35.2-12.5 35.2-32.5 0-19.8-12.5-30.1-32.3-30.1-7.2 0-12.3.7-15.4 1.4V314z"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    gradientUnits: "userSpaceOnUse",
    x1: 130.927,
    y1: 211.034,
    x2: 130.927,
    y2: 151.743
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M111.6 153c3.3-.7 9.1-1.2 14.8-1.2 7.1 0 12.1.9 16.1 3.7 3.5 2.4 5.7 6.2 5.7 11 0 5.3-3.1 10.2-9.3 12.6v.3c6.5 1.7 11.4 6.8 11.4 14.3 0 4.5-1.9 8.9-5.3 12-3.9 3.6-10.5 5.5-20.9 5.5-5.5 0-9.7-.4-12.4-.8V153zm11.2 22.9h4.1c6.4 0 10.2-3.4 10.2-8.2 0-5.8-4.3-7.7-9.3-7.7-2.4 0-3.9.2-4.9.4v15.5zm0 8.2v18.2c1.1.2 2.5.3 4.5.3 6.1 0 11.2-2.7 11.2-9.3 0-6.7-5.8-9.2-11.5-9.2h-4.2z",
    fill: "url(#W)"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    gradientUnits: "userSpaceOnUse",
    x1: 175.321,
    y1: 210.504,
    x2: 175.321,
    y2: 152.197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M191.6 201.1v9.4H159v-58.3h31.4v9.4h-20.2v14.1h19v9.2h-19v16.2h21.4z",
    fill: "url(#X)"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    gradientUnits: "userSpaceOnUse",
    x1: 217.705,
    y1: 215.361,
    x2: 217.705,
    y2: 155.463
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w",
    y: -4.1,
    fill: "url(#Y)"
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    gradientUnits: "userSpaceOnUse",
    x1: 267.255,
    y1: 211.337,
    x2: 267.255,
    y2: 151.287
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M291.7 180.6c0 20.3-10.3 30.7-24.8 30.7-15.4 0-24.1-12.9-24.1-29.8 0-17.4 9.6-30.3 24.9-30.3 16.1.1 24 13.9 24 29.4zm-37.1.7c0 11.4 4.5 20.9 12.7 20.9 8.3 0 12.7-9.3 12.7-21.1 0-10.7-4-20.6-12.6-20.6-8.8 0-12.8 10.1-12.8 20.8z",
    fill: "url(#Z)"
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 327.684,
    y1: 214.704,
    x2: 327.684,
    y2: 156.397
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x",
    y: -4.2,
    fill: "url(#a)"
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 382.846,
    y1: 210.504,
    x2: 382.846,
    y2: 152.197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M399.1 201.1v9.4h-32.6v-58.3h31.4v9.4h-20.2v14.1h19v9.2h-19v16.2h21.4z",
    fill: "url(#b)"
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 443.388,
    y1: 214.704,
    x2: 443.388,
    y2: 156.397
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y",
    y: -4.2,
    fill: "url(#c)"
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 187.449,
    y1: 407.158,
    x2: 187.449,
    y2: 221.855
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M224.6 221.9h38.3l-56.4 185.3h-40.7L112 221.9h39l21 81.9c5.5 21.9 11.1 44.1 14.9 66.5h.7c4.1-22.2 9.6-44.8 15.4-66.5l21.6-81.9z",
    fill: "url(#d)"
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 299.739,
    y1: 407.158,
    x2: 299.739,
    y2: 221.855
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M281.9,407.2V221.9h35.7v185.3H281.9z",
    fill: "url(#e)"
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 412.992,
    y1: 407.158,
    x2: 412.992,
    y2: 220.409
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M353.7 407.2V224.3c11.6-2.2 27.5-3.9 48-3.9 23.4 0 41 4.6 52.8 14.7 11.1 9.4 17.8 24.3 17.8 41.4 0 50.8-42.4 62.2-70.1 62.2-5.1 0-9.4-.2-13-1v69.4h-35.5zm35.4-97.4c3.4.7 7.2 1 12.5 1 22.2 0 35.2-12.5 35.2-32.5 0-19.8-12.5-30.1-32.3-30.1-7.2 0-12.3.7-15.4 1.4v60.2z",
    fill: "url(#f)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 187.449,
    y1: 407.158,
    x2: 187.449,
    y2: 221.855
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M261.8 222.7l-55.9 183.7h-39.5l-53.3-183.7h37.4l20.8 81.3c5.1 20.3 10.9 43.3 14.9 66.4l.1.7h2.1l.1-.7c3.6-19.2 8.5-40.4 15.4-66.4l21.3-81.3h36.6m1.1-.8h-38.3l-21.4 81.9c-5.8 21.7-11.3 44.3-15.4 66.5h-.8c-3.9-22.4-9.4-44.6-14.9-66.5l-21-81.9h-39l53.7 185.3h40.7l56.4-185.3z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 299.739,
    y1: 407.158,
    x2: 299.739,
    y2: 221.855
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M316.8 222.7v183.7h-34.1V222.7h34.1m.8-.8h-35.7v185.3h35.7V221.9z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 412.992,
    y1: 407.158,
    x2: 412.992,
    y2: 220.409
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M401.7 221.2c23.8 0 40.9 4.7 52.3 14.5 11.2 9.5 17.5 24.3 17.5 40.8 0 22.3-8.2 38.9-24.3 49.5-15.8 10.3-35 11.9-45 11.9-5.5 0-9.6-.3-12.9-.9l-1-.2v69.6h-33.8V224.9c13.3-2.4 29.6-3.7 47.2-3.7m0 90.4c22.2 0 36-12.8 36-33.3 0-19.7-12.1-30.9-33.1-30.9-7.6 0-12.7.8-15.6 1.5l-.6.1v61.4l.6.1c3.2.8 6.9 1.1 12.7 1.1m0-91.2c-20.5 0-36.4 1.7-48 3.9v182.9h35.4v-69.4c3.6.7 8 1 13 1 27.7 0 70.1-11.3 70.1-62.2 0-17.1-6.7-32-17.8-41.4-11.8-10.2-29.4-14.8-52.7-14.8zm0 90.4c-5.3 0-9.2-.2-12.5-1v-60.2c3.1-.7 8.2-1.4 15.4-1.4 19.8 0 32.3 10.4 32.3 30.1-.1 19.9-13.1 32.5-35.2 32.5z",
    fill: "url(#i)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 130.927,
    y1: 211.034,
    x2: 130.927,
    y2: 151.743
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M126.4 152.5c7.5 0 12 1 15.6 3.6 3.4 2.3 5.3 6 5.3 10.3 0 5.3-3.3 9.8-8.8 11.8l-.5.2v1.5l.6.2c6.6 1.7 10.8 6.9 10.8 13.5 0 4.4-1.8 8.5-5 11.4-3.9 3.5-10.6 5.3-20.3 5.3-5.2 0-9.1-.3-11.6-.7v-56c3.5-.6 9-1.1 13.9-1.1m-4.4 24.2h4.9c6.6 0 11-3.6 11-9 0-5.5-3.6-8.5-10.1-8.5-2.3 0-3.9.1-5.1.4l-.6.1v17m5.1 26.7c7.5 0 12-3.8 12-10.1 0-7.4-6.4-10-12.3-10H122V203l.6.1c1.2.2 2.5.3 4.6.3m-.8-51.7c-5.7 0-11.4.5-14.8 1.2v57.3c2.7.4 6.9.8 12.4.8 10.4 0 16.9-1.9 20.9-5.5 3.4-3 5.3-7.4 5.3-12 0-7.4-4.9-12.6-11.4-14.3v-.2c6.2-2.4 9.3-7.3 9.3-12.6 0-4.8-2.2-8.6-5.7-11-3.9-2.7-8.9-3.7-16-3.7zm-3.6 24.2v-15.5c1-.2 2.5-.4 4.9-.4 5 0 9.3 1.9 9.3 7.7 0 4.8-3.8 8.2-10.2 8.2h-4zm4.4 26.7c-2 0-3.3-.1-4.5-.3v-18.2h4.2c5.8 0 11.5 2.4 11.5 9.2.1 6.6-5.1 9.3-11.2 9.3z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 175.321,
    y1: 210.504,
    x2: 175.321,
    y2: 152.197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M189.6 153v7.8h-20.2v15.7h19v7.6h-19v17.8h21.4v7.8h-31V153h29.8m.8-.8H159v58.3h32.6v-9.4h-21.4v-16.2h19v-9.2h-19v-14.1h20.2v-9.4z",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 217.705,
    y1: 211.261,
    x2: 217.705,
    y2: 151.363
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M226 152.2c5.2 0 9.1.9 11.1 1.8l-1.8 7.6c-2.8-1.1-5.7-1.6-8.8-1.6-8.8 0-18.2 5.6-18.2 21.5 0 13.2 6.8 21 18.1 21 3.1 0 6.4-.5 8.9-1.4l1.3 7.4c-2.2.9-6.5 1.9-12 1.9-16.3 0-26.4-10.9-26.4-28.4 0-9.4 2.9-17.1 8.3-22.4 4.8-4.8 11.8-7.4 19.5-7.4m0-.8c-15.5 0-28.6 10.3-28.6 30.7 0 17.3 9.7 29.2 27.2 29.2 6 0 10.7-1.1 12.9-2.2l-1.6-9c-2.3 1-6 1.7-9.5 1.7-10.5 0-17.3-7.1-17.3-20.2 0-14.1 7.7-20.7 17.4-20.7 4 0 7.1.9 9.3 1.9l2.2-9.1c-1.6-1-5.7-2.3-12-2.3z",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 267.255,
    y1: 211.337,
    x2: 267.255,
    y2: 151.287
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M267.7 152.1c7.3 0 13.3 2.9 17.4 8.5 3.7 5.1 5.8 12.2 5.8 20 0 18.7-9 29.9-24 29.9-14.2 0-23.3-11.4-23.3-29s9.7-29.4 24.1-29.4m-.4 50.9c8.2 0 13.5-8.6 13.5-21.9 0-10.7-4.1-21.4-13.4-21.4-10 0-13.6 11.7-13.6 21.7 0 12.9 5.4 21.6 13.5 21.6m.4-51.7c-15.2 0-24.9 12.8-24.9 30.3 0 16.9 8.7 29.8 24.1 29.8 14.5 0 24.8-10.4 24.8-30.7 0-15.6-7.9-29.4-24-29.4zm-.4 50.9c-8.3 0-12.7-9.4-12.7-20.9 0-10.7 4-20.9 12.8-20.9 8.6 0 12.6 9.9 12.6 20.6 0 11.8-4.4 21.2-12.7 21.2z",
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 327.684,
    y1: 210.504,
    x2: 327.684,
    y2: 152.197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M352.6 153l3.2 56.7h-9.1l-1-22.3c-.3-7.5-.7-16.7-.6-22.5v-.8h-1.6l-.1.6c-1.6 6.6-3.7 14.3-5.7 21.2l-7 23h-7.3l-6.3-22.6c-1.8-6.2-3.6-14.1-5.1-21.5l-.1-.6h-1.7v.8l-.9 23.2-1.1 21.7h-8.6l3.8-56.7h12.5l6.1 21.3c2.1 7.9 3.7 14.5 4.8 20.5l.1.6h1.5l.1-.6c1.4-6.5 3.1-13.6 5.1-20.5l6.4-21.3h12.6m.7-1h-13.8l-6.6 21.9c-2 7-3.7 14-5.1 20.5h-.2c-1.3-6.7-3-13.5-4.9-20.5l-6.3-21.9h-13.9l-3.9 58.3h10.2l1.1-22.4c.4-7.2.8-15.8.9-23.2h.2c1.4 7.1 3.2 15 5.1 21.6l6.4 23.2h8.5l7.1-23.6c2-6.5 4.1-14.3 5.8-21.2h.2c-.1 5.9.3 15.3.6 23l1.1 22.7h10.7l-3.2-58.4z",
    fill: "url(#n)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 382.846,
    y1: 210.504,
    x2: 382.846,
    y2: 152.197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M397.1 153v7.8H377v15.7h19v7.6h-19v17.8h21.4v7.8h-31V153h29.7m.8-.8h-31.4v58.3h32.6v-9.4h-21.4v-16.2h19v-9.2h-19v-14.1h20.2v-9.4z",
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 443.388,
    y1: 210.504,
    x2: 443.388,
    y2: 152.197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M449.9 153l15.9 56.7h-10.1l-4-14.8-.2-.6h-16.8l-.2.6-3.9 14.8H421l16.1-56.7h12.8m-14 34.4h14.4l-.3-1-3.5-13.3c-.8-3.3-1.7-7.5-2.4-10.9l-.2-1-.1-.6h-1.5l-.1.6-.2.8c-.7 3.5-1.6 7.9-2.4 11l-3.5 13.3-.2 1.1m14.7-35.2h-14.1L420 210.5h11.4l4-15.4H451l4.2 15.4H467l-16.4-58.3zm-13.7 34.4l3.5-13.3 2.6-11.8h.2c.8 3.6 1.7 8.3 2.7 11.9l3.5 13.3h-12.5v-.1z",
    fill: "url(#p)"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M437.7 113.3l-11.9-17.7 16.6 15.1c3.2 2.9 7.9 3.2 11.5.8l28-18.9-22.9 23.8c-3 3.1-3.5 7.8-1.3 11.5l11.2 17.7-13.1-10.3c-5.6-4.8-13.7-5.5-20-1.5l-19 11.9 19.7-19.7c3.4-3.5 3.9-8.8 1.2-12.7z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "r",
    d: "M225.1 84.7l5.5 17.1h16.6l-12.5 10.4 3.9 16.1-13.5-7.5-13.5 7.5 4.4-16.1-12.4-10.4h16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "M225.1 85.7l5.2 16.2.1.2h16l-11.8 9.9-.1.1v.2l3.7 15.5-12.9-7.1-.1-.1-.1.1-12.9 7.1 4.2-15.4.1-.2-.1-.1-11.8-9.9h16l.1-.2 4.4-16.3m0-1l-4.9 17.1h-16.6l12.5 10.4-4.4 16.1 13.5-7.5 13.5 7.5-3.9-16.1 12.5-10.4h-16.6l-5.6-17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t",
    d: "M289.5 85.7l5.2 16.2.1.2h16L299 112l-.1.1v.2l3.7 15.5-12.9-7.1-.1-.1-.1.1-12.9 7.1 4.2-15.4.1-.2-.1-.1-11.8-9.9h16l.1-.2 4.4-16.3m0-1l-4.9 17.1H268l12.5 10.4-4.4 16.1 13.5-7.5 13.5 7.5-3.9-16.1 12.5-10.4H295l-5.5-17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u",
    d: "M351.8 84.7l5.5 17.1h16.6l-12.4 10.4 3.8 16.1-13.5-7.5-13.4 7.5 4.4-16.1-12.5-10.4h16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v",
    d: "M351.9 85.7l5.2 16.2.1.2h16l-11.8 9.9-.1.1v.2l3.7 15.5-12.9-7.1-.1-.1-.1.1-12.9 7.1 4.2-15.4.1-.2-.1-.1-11.8-9.9h16l.1-.2 4.4-16.3m-.1-1l-4.9 17.1h-16.6l12.5 10.4-4.4 16.1 13.5-7.5 13.5 7.5-3.9-16.1 12.5-10.4h-16.6l-5.6-17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w",
    d: "M235.8 166.8c-2.3-1-5.3-1.9-9.3-1.9-9.6 0-17.4 6.6-17.4 20.7 0 13.2 6.7 20.2 17.3 20.2 3.5 0 7.2-.7 9.5-1.7l1.6 9c-2.2 1.1-6.9 2.2-12.9 2.2-17.5 0-27.2-11.9-27.2-29.2 0-20.4 13.1-30.7 28.6-30.7 6.3 0 10.4 1.3 12.1 2.2l-2.3 9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x",
    d: "M353.3 156.4l3.3 58.3H346l-1.1-22.7c-.3-7.7-.7-17.1-.6-23h-.2c-1.7 7-3.8 14.7-5.8 21.2l-7.1 23.6h-8.5l-6.4-23.2c-1.9-6.6-3.7-14.5-5.1-21.6h-.2l-.9 23.2-1.1 22.4h-10.2l3.9-58.3h13.9l6.3 21.9c1.9 7.1 3.6 13.9 4.9 20.5h.2c1.4-6.5 3.1-13.6 5.1-20.5l6.6-21.9h13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y",
    d: "M450.6 156.4l16.3 58.3h-11.8l-4.2-15.4h-15.6l-4 15.4h-11.4l16.5-58.3h14.2zm-13.7 34.4h12.4l-3.5-13.3c-.9-3.6-1.9-8.3-2.7-11.9h-.1c-.8 3.6-1.7 8.4-2.6 11.8l-3.5 13.4z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVipIconEn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/vip_icon_en.e74977c3d2f81809d12aa0e1e0ed2ffe.svg";